<template>
    <div v-if="show" class="chart-container fadeIn faster animated" @click.stop="close" id="chart-container">       
            <div class="chart-wrapper" id="chart-wrapper">
                <svg id="svg" @click.stop="close" style="fill: black;" class="ex"  xmlns="http://www.w3.org/2000/svg" width="14.6" height="14.6" viewBox="0 0 23.635 23.634"><defs></defs><path id="path" class="a" d="M49.982,28.114l-1.766-1.766L38.165,36.4,28.114,26.348l-1.766,1.766L36.4,38.165,26.348,48.216l1.766,1.766L38.165,39.931,48.216,49.982l1.766-1.766L39.931,38.165Z" transform="translate(-26.348 -26.348)"/></svg>
                <h3>Free Shipping over {{freeShipping|currency}} to {{location.zipCode}}</h3>
                <p>To qualify for free shipping, your order merchandise total before savings and estimated tax needs to be at least {{freeShipping|currency}}. (You can’t combine multiple orders to reach that number.) Returns are free within 30 days of delivery on almost everything we sell.</p>
                <p>Some items are excluded from free shipping and free returns.</p>
                <p class="links"><a href="/shipping-policy/41">Shipping Policy</a>  <span>|</span>  <a href="/return-policy/42">Return Policy</a></p>
            </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
    data(){
        return{
            show:false,
        }
    },
    computed:{
        ...mapGetters({
            location:"zipLookUp/getLocation",
            freeShipping:'shippingRates/freeShipping',
        })
    },
    methods:{
        open(){
            this.show = true;
        },
        close($event)
        {
            if(event.target.id == "chart-container" || event.target.id == "svg" || event.target.id == "path"){
                this.show = false;
            }         
        }
    }
}
</script>

<style scoped>
.chart-container{
    position: fixed;
    background-color: rgba(0,0,0,.71);
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 100;
    overflow: auto;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
}
.chart-wrapper{
    border: .25px solid var(--gold_outline);
    max-width: 690px;
    max-height: 490px;
    min-width: 550.17px;
    /* min-height: 348px; */
    background-color: rgba(249, 246, 243,1);
    overflow: auto;
    margin: auto;
    padding: 40px;
    position: relative;
}
.ex{
    /* width: 23px;
    height: 23px; */
    position: absolute;
    cursor: pointer;
    right: 17.87px;
    top: 18px;
}
h3{
    font-size: 26px;
    color: black;
    font-weight: 500;
    margin-bottom: 24px;
    line-height: 31px;
}
p{
    color: black;
    font-size: 16px;
    line-height: 21px;
    font-weight: 300;
    margin-bottom: 30px;
}
h5{
    font-size: 16px;
    font-weight: 500;
}
.links a{
    color: #01614E;
    font-size: 14px;
}
@media only screen and (max-width: 768px){
    .chart-wrapper{
    max-width: 320px;
    max-height: 400px;
    min-width: 320px;
    /* min-height: 348px; */
    }
}
</style>



// WEBPACK FOOTER //
// resources/js/components/partials/ShippingTerms.vue